import {
  AlertIcon,
  DoneIcon,
  ErrorIcon,
  InfoIcon,
  WarrningIcon,
} from '../../icons';
import { Severity } from '../../types';
import { LoadingIcon } from '../Loading';

interface ToastIconProps {
  severity: Severity;
}

export const NotificationToastIcon = ({ severity }: ToastIconProps) => {
  const iconMap: Record<Severity, JSX.Element> = {
    success: <DoneIcon className="size-4 text-[#2FCFD3]" />,
    error: <ErrorIcon className="size-4 text-[#E02D75]" />,
    warning: <WarrningIcon className="size-4 text-[#F0C723]" />,
    info: <InfoIcon className="text-primary size-4" />,
    alert: <AlertIcon className="text-primary size-4" />,
    loading: <LoadingIcon className="text-primary size-4" />,
  };

  return iconMap[severity] || null;
};
